import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import ImageRequest from '@Containers/ImageRequest';
import * as FormatUtils from '@Services/FormatUtils';
import join from 'lodash/join';

export default class StructurePreviewComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.customAttrs = {};
    const { title } = props;
    if (title) {
      this.customAttrs.title = title;
    }
  }

  getNoImageComponent() {
    const { structureId, structureName } = this.props;
    return (
      <div className="rx-picture no-image" {...this.customAttrs}>
        <div className="no-image-content">
          <div>No Structure Preview</div>
          {structureId && <div>RN: {structureId}</div>}
          {structureName && <div>{structureName}</div>}
        </div>
      </div>
    );
  }

  getMixtureNameComponent() {
    const { mixtureName } = this.props;

    return (
      <div className="mixture-name-wrapper">
        <div className="mixture-name"> {(mixtureName || []).join('; ')} </div>
      </div>
    );
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getRegularPreviewComponent() {
    const { previewPathKey, zoom = 0, title, previewPath, chemicalNames } = this.props;
    const altText = title ? <span className="screen-reader-text"> {title} </span> : null;
    const previewUrl = previewPath[previewPathKey] && previewPath[previewPathKey].url;
    const url = previewUrl && FormatUtils.formatPath(previewUrl);
    const image =
      previewPathKey && previewPath[previewPathKey]
        ? {
            ...previewPath[previewPathKey],
            url,
          }
        : FormatUtils.getImageFromPathForZoom(previewPath, zoom, true) || {};

    const imageGenerationRequestsLimit = Auth.isFeatureEnabled(FEATURES.image_generation_requests_limit);

    return image.url ? (
      <div className="structure-preview restrict-select" {...this.customAttrs}>
        {imageGenerationRequestsLimit ? (
          <ImageRequest
            url={image.url}
            // eslint-disable-next-line radix
            limit={parseInt(imageGenerationRequestsLimit)}
            render={({ src }) => (
              <img
                src={src}
                alt={chemicalNames ? join(chemicalNames) : ''}
                loading="lazy"
                draggable="false"
                onDragStart={(e) => {
                  e.preventDefault();
                }}
              />
            )}
          />
        ) : (
          <img
            src={image.url}
            alt={chemicalNames ? join(chemicalNames) : ''}
            draggable="false"
            onDragStart={(e) => {
              e.preventDefault();
            }}
          />
        )}
      </div>
    ) : (
      <div className="rx-picture structure-preview" {...this.customAttrs}>
        <InnerHTML tag="div" className="noimg-label" title={image.label} html={image.label} />
        {altText}
      </div>
    );
  }

  getMarkushPreviewComponent() {
    const { markushPreview, structureId } = this.props;
    const path = FormatUtils.formatPath(markushPreview.url);
    return (
      <div role="img">
        <img
          src={path}
          alt={structureId || ''}
          draggable="false"
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
      </div>
    );
  }

  render() {
    const { markushPreview, previewPath, mixtureName } = this.props;
    if (markushPreview) {
      return this.getMarkushPreviewComponent();
    }
    if (!previewPath) {
      return this.getNoImageComponent();
    }
    if (mixtureName) {
      return this.getMixtureNameComponent();
    }
    return this.getRegularPreviewComponent();
  }
}

StructurePreviewComponent.defaultProps = {
  title: '',
  structureId: '',
  mixtureName: null,
  structureName: null,
};

StructurePreviewComponent.propTypes = {
  title: PropTypes.string,
  structureId: PropTypes.string,
  mixtureName: PropTypes.array,
  structureName: PropTypes.string,
  previewPathKey: PropTypes.string,
  previewPath: PropTypes.object,
  zoom: PropTypes.number,
  markushPreview: PropTypes.object,
  chemicalNames: PropTypes.array,
};
